import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FlashService } from './flash.service';

@Injectable({
    providedIn: 'root'
})
export class SetupService {

    constructor(private http: HttpClient, private router: Router, private flashService: FlashService) {
    }

    GetMenu(appId, optionId) {
        var self = this;
        return self.http.get('/api/ListGrid/Menu/?appId=' + appId + '&appOptId=' + optionId).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetDialog(id) {
        var self = this;
        return self.http.get('/api/ListGrid/Dialog/?id=' + id).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetRecurrenceData(data) {
        var self = this;
        return self.http.post('/api/ListGrid/Recurrence/Get', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    SaveRecurrenceData(data) {
        var self = this;
        return self.http.post('/api/ListGrid/Recurrence/Save', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    GetDataCollection(id) {
        var self = this;
        return self.http.get('/api/ListGrid/DataCollection?id=' + id).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    SaveDataCollection(data) {
        var self = this;
        return self.http.post('/api/ListGrid/SaveDataCollection', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    Search(data) {
        var self = this;
        return self.http.post('/api/Controls/Autocomplete', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    handleSuccess(res) {
        return { success: true, data: res };
    }

    handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false, status: res.error.status };
    }

}